import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const TabsComponent = ({ tabs }) => {
    return (
        <Container>
            <Row>
                <Col>
                    <Tabs defaultActiveKey={tabs[0]?.key || '1'}>
                        {tabs.map((tab) => (
                            <TabPane tab={tab.title} key={tab.key}>
                                {tab.content}
                            </TabPane>
                        ))}
                    </Tabs>
                </Col>
            </Row>
        </Container>
    );
};
export default TabsComponent;